import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'

import { MeetingHubService } from './services/meeting-hub.service'

/** Header sent with API requests so the server can exclude this browser from content-sync echoes. */
export const MEETING_HUB_CONNECTION_HEADER = 'X-Meeting-Hub-Connection'

@Injectable()
export class MeetingConnectionInterceptor implements HttpInterceptor {
    private meetingHub = inject(MeetingHubService)

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const connectionId = this.meetingHub.connectionId
        if (connectionId) {
            req = req.clone({
                setHeaders: { [MEETING_HUB_CONNECTION_HEADER]: connectionId },
            })
        }
        return next.handle(req)
    }
}
